<template>
  <v-dialog
    max-width="750"
    persistent
    v-model="showDialog">
    <v-card class="pa-5">
      <v-card-title>
        <h3>Are you sure you want to delete this client?</h3>
      </v-card-title>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="green darken-1"
          text
          @click="cancelDialog">
          Cancel
        </v-btn>
        <v-btn
          color="red darken-1"
          text
          @click="deleteClient">
          Yes, Delete It!
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ['showDialog'],
  data () {
    return {

    }
  },
  methods: {
    deleteClient () {
      this.$emit('deleteClient')
    },
    cancelDialog () {
      this.$emit('cancelDialog')
    }
  }
}
</script>